import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Container, Navbar, Nav } from 'react-bootstrap';

function Navbars() {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      localStorage.setItem('scrollTo', id);
      navigate('/');
    } else {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <Navbar expand="lg" className="navbar-custom fixed-top bg-white shadow-sm">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="40"
            height="40"
            className="me-2"
          />
          <span className="fw-bold fs-4">R&P Travels</span>
          <img
            src="/assets/navicon.png"
            alt="Icon"
            width="150"
            height="30"
            className="ms-4 d-none d-md-inline"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto text-center">
            <Nav.Link onClick={() => scrollToSection('about')}>About Us</Nav.Link>
            <Nav.Link onClick={() => scrollToSection('services')}>Our Services</Nav.Link>
            <Nav.Link as={Link} to="/certification">Certification</Nav.Link>
            <Nav.Link onClick={() => scrollToSection('contact')}>Contact</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbars;
